import React, { Component } from 'react';
import { connect } from 'react-redux';
import GridPageView from '../shared/GridPageView';
import UserDefinitions from './UserDefinitions';
import { canEditUser } from './UserAccess';

export class UsersPageView extends Component {
  render() {
    return (
      <GridPageView
        {...this.props}
        definitions={UserDefinitions}
        resourceName="users"
        resourceIdentifier="uuid"
        multipleName="Gebruikers"
        singleName="Gebruiker"
        isRowClickable={(user) => canEditUser(this.props.currentUserRoles, user.roles)}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  currentUserRoles: (state.user && state.user.roles) || []
});

export default connect(mapStateToProps)(UsersPageView);
